<div class="savings-plans-container">
  <div class="savings-plans-scroll pb-4" [class.pr-2]="facade.isMultiSavingsPlanOrder$ | async">
    @if (facade.savingsPlanToUpdate$ | async; as savingsPlan) {
      @if (facade.selectedAsset$ | async; as asset) {
        <ng-container *ngTemplateOutlet="confirmAssets; context: { asset, savingsPlan }" />
      }
    } @else {
      @for (savingsPlan of facade.multiSavingsPlans$ | async; track savingsPlan.isin; let isLast = $last) {
        <ng-container *ngTemplateOutlet="confirmAssets; context: { asset: savingsPlan.asset, savingsPlan }" />
        @if (!isLast) {
          <hr class="less-margin" />
        }
      }
    }
  </div>
  <div class="savings-plans-wrapper"></div>
</div>

<ng-template #confirmAssets let-asset="asset" let-savingsPlan="savingsPlan">
  @if (asset && savingsPlan) {
    <div class="row">
      <div class="col-8 font-bold" data-zid="savings-plan-long-name">{{ asset.longName }}</div>
      <div class="col-4 text-right font-bold" data-zid="savings-plan-amount">{{ savingsPlan.amount | currency }}</div>
    </div>
    <div class="row">
      <div class="col-8 text-size-small" data-zid="savings-plan-identifier">
        @if (asset.instrumentType === InstrumentType.Crypto) {
          {{ asset.shortName }}
        } @else {
          {{ asset.isin }} / {{ asset.wkn }}
        }
      </div>
      <div class="col-4 text-size-small text-right" data-zid="savings-plan-exchange">
        {{ 'savings-plan.savings-plan-summary.exchange' | transloco }}: {{ asset.marketName }}
      </div>
    </div>
    @if (asset.instrumentType === InstrumentType.Crypto && savingsPlan.asset?.tradingFees?.feeSavingsplanPct) {
      <div class="row">
        <div class="col-8">{{ 'savings-plan.savings-plan-summary.provision' | transloco }}</div>
        <div class="col-4 font-bold text-right">{{ savingsPlan.asset.tradingFees.feeSavingsplanPct | number: '1.2-2' }} %</div>
      </div>
      <div class="row">
        <div class="col-8">{{ 'savings-plan.savings-plan-summary.discount' | transloco }}</div>
        <div class="col-4 font-bold text-right zero-text course-green">
          {{ savingsPlan.asset.tradingFees.feeSavingsplanPct * -1 | number: '1.2-2' }} %
        </div>
      </div>
    }
    <div class="row">
      <div class="col-12" data-zid="savings-plan-links">
        @if (asset.baseInfoLink) {
          <a [href]="asset.baseInfoLink" class="link-secondary" target="_blank" rel="noopener noreferrer">
            {{ 'savings-plan.savings-plan-summary.links.baseInfoLink' | transloco }}</a
          >,
        }
        @if (asset.salesbrochure) {
          <a [href]="asset.salesbrochure" class="link-secondary" target="_blank" rel="noopener noreferrer">
            {{ 'savings-plan.savings-plan-summary.links.salesbrochure' | transloco }}</a
          >,
        }
        @if (asset.semiAnnualReport) {
          <a [href]="asset.semiAnnualReport" class="link-secondary" target="_blank" rel="noopener noreferrer">
            {{ 'savings-plan.savings-plan-summary.links.semiAnnualReport' | transloco }}</a
          >,
        }
        @if (asset.annualReport) {
          <a [href]="asset.annualReport" class="link-secondary" target="_blank" rel="noopener noreferrer">
            {{ 'savings-plan.savings-plan-summary.links.annualReport' | transloco }}</a
          >,
        }
        <div [zeroLoadingIndicator]="facade.loadingExante$ | async">
          @if (facade.loadingExante$ | async) {
            {{ 'trade.confirm.exante.loading' | transloco }}
          } @else {
            <a class="link-secondary" [href]="facade.exante$ | async | exanteUri: asset?.isin" target="_blank" rel="noopener noreferrer">{{
              'trade.confirm.exante.link' | transloco
            }}</a>
          }
        </div>
      </div>
    </div>
  }
</ng-template>
